import { render, staticRenderFns } from "./NewBarcodeIndexingEditor.vue?vue&type=template&id=d3510810&scoped=true&"
import script from "./NewBarcodeIndexingEditor.vue?vue&type=script&lang=js&"
export * from "./NewBarcodeIndexingEditor.vue?vue&type=script&lang=js&"
import style0 from "./NewBarcodeIndexingEditor.vue?vue&type=style&index=0&id=d3510810&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3510810",
  null
  
)

export default component.exports